import React from "react";
import { Button } from "@material-ui/core";
import CommonDialog from "./CommonDialog";

const ReconnectDialog = ({ open, room, playerName, onRejoin, onLeave }) => {
  return (
    <CommonDialog
      open={open}
      onClose={onLeave}
      title="🔄 Reconnect to Game?"
      maxWidth="sm"
      PaperProps={{
        className: "reconnect-dialog-paper"
      }}
      titleStyle={{
        className: "reconnect-dialog-title"
      }}
      contentStyle={{
        className: "reconnect-dialog-content"
      }}
      actions={
        <>
        <Button
          onClick={onLeave}
          variant="outlined"
          className="reconnect-dialog-button-leave"
        >
          Leave Game
        </Button>
        <Button
          onClick={onRejoin}
          variant="contained"
          color="primary"
          className="reconnect-dialog-button-rejoin"
        >
          Rejoin Game
        </Button>
        </>
      }
      actionsStyle={{
        className: "reconnect-dialog-actions"
      }}
    >
      <p className="reconnect-dialog-message">
        We found an active game session:
      </p>
      <div className="reconnect-dialog-session-info">
        <div className="reconnect-dialog-session-item">
          <strong>Room:</strong> {room}
        </div>
        <div className="reconnect-dialog-session-item">
          <strong>Player:</strong> {playerName}
        </div>
      </div>
      <p className="reconnect-dialog-question">
        Would you like to rejoin this game or start fresh?
      </p>
    </CommonDialog>
  );
};

export default ReconnectDialog;

